import { render, staticRenderFns } from "./SectionInput.vue?vue&type=template&id=32bedd41&scoped=true&"
import script from "./SectionInput.vue?vue&type=script&lang=ts&"
export * from "./SectionInput.vue?vue&type=script&lang=ts&"
import style0 from "./SectionInput.vue?vue&type=style&index=0&id=32bedd41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bedd41",
  null
  
)

export default component.exports